import React from 'react';
import { Grid, Stack } from '@mui/material';
import PlayerGroupName from './PlayerGroupName';
import PoolsTitleBarActions from './PoolsTitleBarActions';

const PlayerGroupSection = ({ playerGroupName, pool, isAdmin }) => (
    <Grid item sm={4} xs={12} sx={{ mb: { xs: 2, sm: 0 }, pl: { xs: 0.5, sm: 0 } }}>
        {!isAdmin && <PlayerGroupName playerGroupName={playerGroupName} />}
        {isAdmin && (
            <Stack direction="row" spacing={10} sx={{ width: '100%' }}>
                <PlayerGroupName playerGroupName={playerGroupName} />
                <Grid sx={{ display: { xs: 'flex', sm: 'none' }, ml: 'auto' }}>
                    <PoolsTitleBarActions pool={pool} />
                </Grid>
            </Stack>
        )}
    </Grid>
);

export default PlayerGroupSection;
